import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { layoutSelector } from 'core/store/layout/selectors';
import { useAppSelector } from 'core/store/store.utils';
import {
  getNavigate,
  setAutoprospectionError,
  setMaintenanceError,
  setNavigate,
} from 'shared/utils/layout-errors.utils';

export const LayoutErrorsContainer = ({ children }: { children: React.ReactNode }) => {
  const navigate = useNavigate();
  const layout = useAppSelector(layoutSelector);
  const {
    layoutError: { autoprospection, maintenance },
  } = layout;

  useEffect(() => {
    if (!getNavigate()) setNavigate(navigate);

    setAutoprospectionError(autoprospection);
    setMaintenanceError(maintenance);
  }, [autoprospection, maintenance, navigate]);

  return children;
};
